import * as d3 from 'd3';

// Stable per-(asset, version) color. We use asset hue + version lightness offset.
const assetHueCache = new Map();
export function assetHue(assetId) {
  if (!assetHueCache.has(assetId)) {
    // Simple hash to hue.
    let h = 0;
    for (let i = 0; i < assetId.length; i++) h = (h * 31 + assetId.charCodeAt(i)) | 0;
    assetHueCache.set(assetId, ((h % 360) + 360) % 360);
  }
  return assetHueCache.get(assetId);
}

export function versionColor(assetId, version) {
  const hue = assetHue(assetId);
  // Progress through lightness/saturation grid so successive versions are distinguishable.
  const lightness = 40 + (version % 8) * 6; // 40..82
  const sat = 65 - (version % 4) * 6;
  return d3.hsl(hue, sat / 100, lightness / 100).formatHex();
}

export function deltaGradientColors(assetId, fromV, toV) {
  return [versionColor(assetId, fromV), versionColor(assetId, toV)];
}

export function kindColor(kind) {
  return {
    full: '#4ea1ff',
    delta: '#7ee787',
    cache: '#b392f0',
    revalidated: '#56d1c9',
  }[kind] || '#ccc';
}

export function failureColor() { return '#ff6b6b'; }
